exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__card___2P_1t{position:relative;max-width:100%;width:250px;min-width:250px;min-height:350px;display:flex;flex-flow:column;background-color:#ecf0f1;border-radius:.25rem;margin:1rem;user-select:none;transition:.25s}.styles__card___2P_1t.styles__float___HWEwV:hover{transform:translateY(-8px);box-shadow:0 10px 10px -10px #7f8c8d}", ""]);

// exports
exports.locals = {
	"card": "styles__card___2P_1t",
	"float": "styles__float___HWEwV"
};